export default "__VITE_ASSET__0939bb0a__"